import { useCallback, useEffect, useRef } from 'react';
const useResize = (ref, onResize) => {
    const refCallback = useRef(onResize);
    refCallback.current = onResize;
    const handleOnResize = useCallback((event) => {
        if (ref.current) {
            refCallback.current(event);
        }
    }, [ref, refCallback]);
    useEffect(() => {
        window.addEventListener('resize', handleOnResize);
        return () => {
            window.removeEventListener('resize', handleOnResize);
        };
    }, [handleOnResize]);
};
export { useResize };
//# sourceMappingURL=useResize.js.map